(function() {
  'use strict';

  var registry = window.PooleaseSectionScripts = window.PooleaseSectionScripts || {};

  function initSection(section) {
    if (!section || section.dataset.productHeroReady === 'true') return;

    var select = section.querySelector('[data-variant-select]');
    var variantsJson = section.querySelector('[data-product-variants]');
    if (!select || !variantsJson) return;

    var optionRadios = section.querySelectorAll('input[type="radio"][name^="hero-option-"]');
    var modelRadios = section.querySelectorAll('input[type="radio"][data-variant-id]');
    var radios = section.querySelectorAll('input[type="radio"][name^="hero-option-"], input[type="radio"][data-variant-id]');
    if (!radios.length) return; /* single/default variant: nothing to wire */

    var variants = [];
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

    function selectedOpts() {
      var opts = {};
      optionRadios.forEach(function(r) {
        if (r.checked) opts[r.name.replace('hero-option-', '')] = r.value;
      });
      return opts;
    }

    function findVariantId() {
      for (var modelIndex = 0; modelIndex < modelRadios.length; modelIndex++) {
        if (modelRadios[modelIndex].checked) return Number(modelRadios[modelIndex].dataset.variantId);
      }
      var opts = selectedOpts();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== opts[String(j + 1)]) { match = false; break; }
        }
        if (match) return v.id;
      }
      return null;
    }

    function update() {
      var id = findVariantId();
      if (!id) return;
      select.value = id;
      var opt = select.options[select.selectedIndex];
      if (!opt) return;

      var priceEl = section.querySelector('[data-price]');
      var compareEl = section.querySelector('[data-compare]');
      if (priceEl) priceEl.textContent = opt.getAttribute('data-price');

      var available = opt.getAttribute('data-available') === 'true';
      var atc = section.querySelector('[data-product-hero-atc]');
      var payment = section.querySelector('[data-product-hero-payment]');
      var availability = section.querySelector('[data-product-hero-availability]');
      if (atc) {
        atc.disabled = !available;
        atc.setAttribute('aria-disabled', available ? 'false' : 'true');
        atc.textContent = available ? 'Add to Cart' : 'Sold out';
      }
      if (payment) payment.hidden = !available;
      if (availability) availability.textContent = available ? 'Available for purchase' : 'Sold out';

      if (compareEl) {
        var has = opt.getAttribute('data-has-compare') === 'true';
        compareEl.style.display = has ? '' : 'none';
        if (has) {
          var s = compareEl.querySelector('s');
          if (s) s.textContent = opt.getAttribute('data-compare');
        }
      }

      radios.forEach(function(r) {
        var label = r.closest('.product-hero__swatch, .product-hero__model-card');
        if (label) label.classList.toggle('is-selected', r.checked);
      });

      /* Notify Shopify dynamic checkout button to follow the new variant */
      select.dispatchEvent(new Event('change', { bubbles: true }));

      if (section.dataset.variantNavigation === 'reload' && window.PooleaseVariantNavigation) {
        window.PooleaseVariantNavigation.go(section.dataset.productUrl, id);
      }
    }

    section.dataset.productHeroReady = 'true';
    radios.forEach(function(r) { r.addEventListener('change', update); });
  }

  function initAll(root) {
    var scope = root || document;
    var selector = '[data-section-type="product-hero"]';
    if (scope.matches && scope.matches(selector)) initSection(scope);
    var sections = scope.querySelectorAll ? scope.querySelectorAll(selector) : [];
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (registry.productHero) {
    registry.productHero(document);
    return;
  }
  registry.productHero = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
})();
